import {TextInputWithoutContainer} from "../../../../component/TextInput/TextInput";
import {TreeSelectWithoutContainer} from "../../../../component/TreeSelect/TreeSelect";
import {listToTree} from "../../../../assets/functions";
import {useEffect, useState} from "react";
import {getAllBrandsObject} from "../../../brands/functions";
import {getAllProductCategoriesObject} from "../../../ProductCategories/functions";
import {getAllManagersObject} from "../../../Managers/functions";
import Loading from "../../../../component/Loading/Loading";
import {SelectWithoutContainer} from "../../../../component/Select/Select";

const FilterForm = ({searchParams , onSubmit}) => {
    const [isLoading, setIsLoading] = useState(true);
    const [searchForm , setSearchForm] = useState({...searchParams});
    const [allBrand, setAllBrand] = useState([]);
    const [allProductCategory, setAllProductCategory] = useState([]);
    const [allManagers, setAllManagers] = useState([]);

    const defaultSearchParams = {
        name: "" ,
        brandId: "" ,
        productCategoryId: "" ,
        hasPrice: false ,
        hasPicture: false ,
        hasInstallment: false ,
        managerId: "" ,
        userLevel: "gold" ,
        sortBy: "NEWEST" ,
        length : 20
    }
    const userLevelOptions = [
        {
            label: "عادی",
            value: "normal"
        },{
            label: "نقره ای",
            value: "silver"
        },{
            label: "طلایی",
            value: "gold"
        }
    ]
    const sortByOptions = [
        {
            label: "جدیدترین",
            value: "NEWEST"
        },{
            label: "قدیمی ترین",
            value: "OLDEST"
        },{
            label: "ارزان ترین",
            value: "CHEAPEST"
        },{
            label: "گران ترین",
            value: "MOST_EXPENSIVE"
        },{
            label: "پرفروش ترین",
            value: "MOST_SELL"
        }
    ]
    const lengthOptions = [
        {
            label: "10",
            value: "10"
        },
        {
            label: "20",
            value: "20"
        },{
            label: "50",
            value: "50"
        },{
            label: "100",
            value: "100"
        }
    ]

    const changeSearchForm = (key, value) => {
        setSearchForm({...searchForm , [key] : value });
    }

    useEffect(() => {
        (async () => {
            setAllBrand([...await getAllBrandsObject()]);
            setAllProductCategory([...await getAllProductCategoriesObject()]);
            setAllManagers([...await getAllManagersObject()]);

            setIsLoading(false);
        })();

    }, []);

    if (isLoading)
        return <Loading/>

    return (
        <div className="card">
            <div className="card-body">
                <div className="filter-box">
                    <div className="row">
                        <label className="card-title text-center">فیلتر محصولات</label>
                        <div className="col-md-3 mt-4">
                            <TextInputWithoutContainer label={"نام محصول"}
                                                       value={searchForm.name || defaultSearchParams.name}
                                                       onChange={(value) => {
                                                           changeSearchForm("name", value)
                                                       }}/>
                        </div>

                        <div className="col-md-3 mt-4">
                            <TreeSelectWithoutContainer mode={"radioSelect"} label={"برند"}
                                                        data={listToTree(allBrand, [parseInt(searchForm.brandId || defaultSearchParams.brandId)])}
                                                        onChange={(value) => {
                                                            const newBrandId = value.length == 1 ? value[0] : "";
                                                            changeSearchForm("brandId", newBrandId)
                                                        }}/>
                        </div>

                        <div className="col-md-3 mt-4">
                            <TreeSelectWithoutContainer mode={"radioSelect"} label={"دسته بندی"}
                                                        data={listToTree(allProductCategory, [parseInt(searchForm.productCategoryId || defaultSearchParams.productCategoryId)])}
                                                        onChange={(value) => {
                                                            const newProductCategoryId = value.length == 1 ? value[0] : "";
                                                            changeSearchForm("productCategoryId", newProductCategoryId)
                                                        }}/>
                        </div>

                        <div className="col-md-3 mt-4">
                            <div className="">
                                <input className="form-check-input" type="checkbox" id="hasPrice"
                                       checked={JSON.parse(searchForm.hasPrice || defaultSearchParams.hasPrice)}
                                       onChange={() => {
                                           changeSearchForm("hasPrice", !JSON.parse(searchForm.hasPrice || defaultSearchParams.hasPrice))
                                       }}/>
                                <label className="form-check-label me-1" htmlFor="hasPrice">
                                    فقط قیمت دار
                                </label>
                            </div>
                            <div className="">
                                <input className="form-check-input" name={"hasPicture"} type="checkbox"
                                       id="hasPicture"
                                       checked={JSON.parse(searchForm.hasPicture || defaultSearchParams.hasPicture)}
                                       onChange={() => {
                                           changeSearchForm("hasPicture", !JSON.parse(searchForm.hasPicture || defaultSearchParams.hasPicture))
                                       }}/>
                                <label className="form-check-label me-1" htmlFor="hasPicture">
                                    فقط عکس دار
                                </label>
                            </div>
                            <div className="">
                                <input className="form-check-input" name={"hasInstallment"} type="checkbox"
                                       id="hasInstallment"
                                       checked={JSON.parse(searchForm.hasInstallment || defaultSearchParams.hasInstallment)}
                                       onChange={() => {
                                           changeSearchForm("hasInstallment", !JSON.parse(searchForm.hasInstallment || defaultSearchParams.hasInstallment))
                                       }}/>
                                <label className="form-check-label me-1" htmlFor="hasInstallment">
                                    فقط قسطی
                                </label>
                            </div>

                        </div>

                        <div className="col-md-3 mt-4">
                            <TreeSelectWithoutContainer mode={"radioSelect"} label={"مدیر"}
                                                        data={listToTree(allManagers, [parseInt(searchForm.managerId || defaultSearchParams.managerId)])}
                                                        onChange={(value) => {
                                                            const newManagerId = value.length == 1 ? value[0] : "";
                                                            changeSearchForm("managerId", newManagerId)
                                                        }}/>
                        </div>

                        <div className="col-md-3 mt-4">
                            <SelectWithoutContainer label={"مبنای سطح کاربری"} options={userLevelOptions}
                                                    value={searchForm.userLevel || defaultSearchParams.userLevel}
                                                    onChange={(value) => {
                                                        changeSearchForm("userLevel", value)
                                                    }}/>
                        </div>

                        <div className="col-md-2 mt-4">
                            <SelectWithoutContainer label={"تعداد در هر صفحه"} options={lengthOptions}
                                                    value={searchForm.length || defaultSearchParams.length}
                                                    onChange={(value) => {
                                                        changeSearchForm("length", value)
                                                    }}/>
                        </div>

                        <div className="col-md-3 mt-4">
                            <SelectWithoutContainer label={"مرتب سازی بر اساس"} options={sortByOptions}
                                                    value={searchForm.sortBy || defaultSearchParams.sortBy}
                                                    onChange={(value) => {
                                                        changeSearchForm("sortBy", value)
                                                    }}/>
                        </div>

                        <div className="col-12">
                            <button className={"btn btn-primary w-100 mt-2"} onClick={() => {onSubmit(searchForm)}}>جست و جو</button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}

export default FilterForm;